// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"YB-z","breadcrumbForward":"ZB-z","breadcrumbBack":"_B-z","selected":"aC-z"};